/* EMERY — Product Card Mobile Swipe (mobile-only, with desktop teardown) */
(function () {
  // ---- Device helpers -------------------------------------------------------
  const isMobile = () => {
    const vw = Math.min(window.innerWidth, document.documentElement.clientWidth || window.innerWidth);
    return vw <= 767 &&
           window.matchMedia('(pointer: coarse)').matches &&
           window.matchMedia('(hover: none)').matches;
  };

  // ---- State helpers --------------------------------------------------------
  function setIndex(mediaEl, idx) {
    mediaEl.dataset.snapIndex = String(idx);
    const fig = mediaEl.closest('.product-card__figure');
    if (fig) fig.dataset.snapIndex = String(idx);
  }

  function wrapAsSlide(node) {
    const slide = document.createElement('div');
    slide.className = 'touch-swipe-slide';
    slide.appendChild(node);
    return slide;
  }

  function buildTrack(mediaEl) {
    if (mediaEl.__track) return mediaEl.__track;

    const primary = mediaEl.querySelector('.product-card__image--primary');
    const secondary = mediaEl.querySelector('.product-card__image--secondary');
    if (!primary) return null;

    // Create horizontal track (primary then secondary if present)
    const track = document.createElement('div');
    track.className = 'touch-swipe-track';
    Object.assign(track.style, {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      gap: '0',
      transform: 'translateX(0%)',
      willChange: 'transform'
    });

    [primary, secondary].filter(Boolean).forEach(img => {
      Object.assign(img.style, {
        position: 'static',
        inset: 'auto',
        display: 'block',
        width: '100%',
        height: 'auto',
        opacity: '1',
        transform: 'none',
        visibility: 'visible'
      });
      track.appendChild(wrapAsSlide(img));
    });

    mediaEl.innerHTML = '';
    mediaEl.appendChild(track);
    mediaEl.style.overflow = 'hidden';
    mediaEl.__track = track;
    return track;
  }

  // ---- Build one media element ---------------------------------------------
  function initOne(mediaEl) {
    if (mediaEl.__swipeBound) return;

    const track = buildTrack(mediaEl);
    if (!track) return;

    mediaEl.__swipeBound = true;
    setIndex(mediaEl, 0);

    let index = 0; // 0 primary, 1 secondary
    let startX = 0, startY = 0, width = mediaEl.clientWidth || 1;
    let dragging = false, suppressClick = false;
    const THRESHOLD = 0.18;   // swipe distance portion to change slide
    const RESIST = 0.35;      // edge resistance
    const SNAP_MS = 220;      // snap animation duration

    function setTransform(pct) { track.style.transform = `translateX(${pct}%)`; }
    function follow(dx) {
      const atFirst = index === 0 && dx > 0;
      const atLast  = index === 1 && dx < 0;
      const resistDx = (atFirst || atLast) ? dx * RESIST : dx;
      const pct = (-index * 100) + (resistDx / width * 100);
      setTransform(pct);
    }
    function snap(to) {
      index = to;
      setIndex(mediaEl, index);
      track.style.transition = `transform ${SNAP_MS}ms ease-out`;
      setTransform(-index * 100);
      const done = () => { track.style.transition = ''; track.removeEventListener('transitionend', done); };
      track.addEventListener('transitionend', done);
    }

    // Keep alignment on size changes
    let ro;
    if ('ResizeObserver' in window) {
      ro = new ResizeObserver(() => {
        width = mediaEl.clientWidth || 1;
        setTransform(-index * 100);
      });
      try { ro.observe(mediaEl); } catch(_) {}
    }

    mediaEl.addEventListener('touchstart', (e) => {
      const t = e.touches[0];
      startX = t.clientX; startY = t.clientY;
      width = mediaEl.clientWidth || 1;
      dragging = true; suppressClick = false;
      track.style.transition = '';
    }, { passive: true });

    mediaEl.addEventListener('touchmove', (e) => {
      if (!dragging) return;
      const t = e.touches[0];
      const dx = t.clientX - startX;
      const dy = t.clientY - startY;

      // If vertical scroll is stronger, give up
      if (Math.abs(dy) > Math.abs(dx)) {
        dragging = false; setTransform(-index * 100);
        return;
      }

      e.preventDefault(); // prevent page scroll while swiping
      e.stopPropagation(); // critical inside related-products slider
      follow(dx);
      suppressClick = Math.abs(dx) > 6;
    }, { passive: false });

    mediaEl.addEventListener('touchend', (e) => {
      if (!dragging) return;
      const dx = e.changedTouches[0].clientX - startX;
      const moved = Math.abs(dx) / (width || 1);
      if (moved > THRESHOLD) {
        if (dx < 0 && index === 0) snap(1);
        else if (dx > 0 && index === 1) snap(0);
        else snap(index);
      } else {
        snap(index);
      }
      dragging = false;
    }, { passive: true });

    // Prevent accidental navigation after a drag
    mediaEl.addEventListener('click', (e) => {
      if (suppressClick) { e.preventDefault(); e.stopPropagation(); suppressClick = false; }
    }, true);
  }

  // ---- Remove swipe DOM on non-mobile --------------------------------------
  function teardown(root = document) {
    root.querySelectorAll('.product-card .product-card__media').forEach((mediaEl) => {
      const track = mediaEl.__track;
      if (!track) return;

      const imgs = [];
      track.querySelectorAll('.touch-swipe-slide').forEach((slide) => {
        const child = slide.firstElementChild;
        if (child) imgs.push(child);
      });

      mediaEl.innerHTML = '';
      imgs.forEach((img) => {
        // Clean inline styles we set
        img.style.position = '';
        img.style.inset = '';
        img.style.display = '';
        img.style.width = '';
        img.style.height = '';
        img.style.opacity = '';
        img.style.transform = '';
        img.style.visibility = '';
        mediaEl.appendChild(img);
      });

      delete mediaEl.__track;
      delete mediaEl.__swipeBound;
      mediaEl.removeAttribute('data-snap-index');
      const fig = mediaEl.closest('.product-card__figure');
      if (fig) fig.removeAttribute('data-snap-index');
    });
  }

  // ---- Init across a root ---------------------------------------------------
  function init(root = document) {
    if (!isMobile()) return;
    root.querySelectorAll('.product-card .product-card__media').forEach(initOne);
  }

  // ---- Boot -----------------------------------------------------------------
  document.addEventListener('DOMContentLoaded', () => {
    const applyMode = () => {
      if (isMobile()) {
        init(document);
      } else {
        teardown(document);
      }
    };

    applyMode();
    window.addEventListener('resize', applyMode);
    window.addEventListener('orientationchange', applyMode);

    // Shopify section & recommendation events
    document.addEventListener('shopify:section:load', (e) => applyMode());
    document.addEventListener('product-recommendations:loaded', (e) => applyMode());
    document.addEventListener('shopify:block:select', (e) => applyMode());
    document.addEventListener('shopify:block:deselect', (e) => applyMode());

    // Observe newly injected nodes; only act on mobile
    const mo = new MutationObserver((muts) => {
      if (!isMobile()) return;
      for (const m of muts) {
        m.addedNodes && m.addedNodes.forEach((n) => {
          if (!(n instanceof Element)) return;
          if (n.matches && n.matches('.product-card .product-card__media')) initOne(n);
          n.querySelectorAll && n.querySelectorAll('.product-card .product-card__media').forEach(initOne);
        });
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });

    // Optional manual hook (for debugging)
    window.initMobileSlider = () => applyMode();
  });
})();
